export default {
  CONTENT: 'CONTENT',
  DIVIDER: 'DIVIDER',
  HEADER: 'HEADER'
};